import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import type {
  DeleteOrganizationInvitePayload,
  DeleteOrganizationInviteInput,
} from "@casey/db-types";

const DELETE_ORGANIZATION_INVITE = gql`
  mutation DeleteOrganizationInvite($id: UUID!) {
    deleteOrganizationInvite(input: { id: $id }) {
      organizationInvite {
        id
        token
      }
      messages {
        level
        message
        path
      }
    }
  }
`;

export function useDeleteOrganizationInvite() {
  return useMutation<
    { deleteTeamInvite: DeleteOrganizationInvitePayload },
    DeleteOrganizationInviteInput
  >(DELETE_ORGANIZATION_INVITE);
}
